import ImportHelper from './import.helper'

const GeneralView = () => { return ImportHelper.importAll(require.context("../assets/images/GeneralView/", true, /\.webp/)); }

export const ContextLoader = {
    "General View": GeneralView,
    "Torre 1": GeneralView,
}
